import getCookie from "@gerenciatd/next13.utils.common.get-cookie";

const shouldLoadDyna = (probability = 10) => {
  let res = false;
  let probability2Apply = probability;
  if (typeof window !== "undefined") {
    const cookiesAcepted = getCookie("OptanonAlertBoxClosed");
    const urlParams = new URLSearchParams(window.location.search);
    let paramValue = urlParams.get("dyna");
    if (paramValue) {
      probability2Apply = parseInt(paramValue, 10);
    }
    res = cookiesAcepted ? Math.random() < probability2Apply / 100 : false;
  }
  return res;
};

export default shouldLoadDyna;